<template>
    <div v-if="Object.keys(doughnutsChartPaymentMethod).length > 0">
        <doughnut-chart id="doughnut-chart-size" :height="height" :dataTableByPaymentMethod="dataTableByPaymentMethod"
            :chart-data="doughnutsChartPaymentMethod.chartData" :extra-options="doughnutsChartPaymentMethod.extraOptions">
        </doughnut-chart>
    </div>
</template>

<script>
const defaultObject = {
    chartData: {
        labels: [],
        datasets: [{
            data: [],
            backgroundColor: [],
            barThickness: 6,
            maxBarThickness: 5,
        }],
    },
    extraOptions: {
        cutoutPercentage: 45,
        legend: {
            display: true,
            position: 'bottom',
        },
        animation: false,
        transitions: {
            ative: {
                animation: { duration: 0, }
            }
        },
        tooltips: {
            mode: 'point',
            callbacks: {
                label: function (tooltipItem, data) { return data.labels[tooltipItem.index] },
            }
        },
    }
}

import DoughnutChart from '@/components/Charts/DoughnutChart';
import { mapGetters } from 'vuex';

export default {
    component: 'DoughnutChartPagamento',

    components: {
        DoughnutChart,
    },

    props: {
        height: {
            type: Number,
            default: 250
        },

        hideDoughnut: {
          type: Boolean,
          default: false
        },

        fetchProgress: {
            type: Number,
            default: 0 | 100
        },

        totalPaidValue: {
            type: Number,
            default: 0.00,
        },

        formattedPaidBillItems: {
            type: Array,
            default: []
        },

        dataTableByPaymentMethod: {
            type: Array | Object,
            default: [],
        },

        hideWhilePrintingPDF: {
            type: Boolean,
            default: false,
        }
    },

    data: () => {
        return {
            defaultChart: defaultObject,
        }
    },

    computed: {
        ...mapGetters('report', {
            totalOnlinePaidBillItems: 'getTotalOnlinePaidBillItems',
            totalLocalPaidBillItems: 'getTotalLocalPaidBillItems',
        }),

        doughnutsChartPaymentMethod() {
            if(this.fetchProgress > 0 && this.fetchProgress < 100){
                this.defaultChart = defaultObject
                return this.defaultChart
            }

            else if(this.fetchProgress == 0 || this.fetchProgress == 100){
                if (!Object.keys(this.dataTableByPaymentMethod).length) {
                    return {}
                }

                var dados = Object.values(this.dataTableByPaymentMethod)
                var labels = dados.map(function (payment_method, idx) {
                 return { label: payment_method.title, size: payment_method.value }
                 })

                labels = labels.filter(item=>(item.label != 'Cortesia' && item.label != 'POS - Cortesia'))
                var localOnly = false
                if (labels.length == 1 && labels[0]['label'] == 'Local') {
                    labels[0]['size'] = 1
                    localOnly = true
                }

                labels = labels.sort((curr, prox) => { return curr.size < prox.size })
                this.defaultChart = {
                    chartData: {
                        labels: labels.map(function (label, idx) {
                            let totalPaidCount = this.totalBillItems
                            let currSize = label.size
                            if (localOnly) {
                                totalPaidCount = 1
                                currSize = 0
                            }
                            return label.label + ' :: R$' + currSize.toFixed(2).replace('.', ',') + ' (' + (label.size * 100 / (totalPaidCount)).toFixed(2).replace('.', ',') + '%)'
                        }, { localOnly: localOnly, totalBillItems: this.totalPaidValue }),   //(this.totalOnlinePaidBillItems + this.totalLocalPaidBillItems)
                        datasets: [{
                            data: labels.map(function (label, idx) { return label.size }),
                            backgroundColor: this.colors,
                            barThickness: 6,
                            maxBarThickness: 5,
                        }],
                    },
                    extraOptions: {
                        cutoutPercentage: this.hideDoughnut?100:defaultObject.extraOptions.cutoutPercentage,
                        legend: {
                            display: true,
                            position: 'left',
                        },
                        animation: false,
                        transitions: {
                            ative: {
                                animation: { duration: 0, }
                            }
                        },
                        tooltips: {
                            mode: 'point',
                            callbacks: {
                                label: function (tooltipItem, data) { return data.labels[tooltipItem.index] },
                            }
                        },
                    }
                }
                return this.defaultChart;
            }
        }
    },

}
</script>
